import React, { useState } from 'react';
import { Info, X } from 'lucide-react';

const AboutModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Info Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed top-6 right-6 p-2 rounded-full bg-gray-800/50 border border-gray-700/50 backdrop-blur-lg hover:bg-gray-700/50 transition-colors duration-200 z-50"
      >
        <Info className="w-5 h-5 text-gray-400" />
      </button>

      {/* Modal Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setIsOpen(false)}
        >
          {/* Modal Content */}
          <div 
            className="bg-gray-900/95 backdrop-blur-lg border border-gray-800 rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
            onClick={e => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="p-6 border-b border-gray-800 flex justify-between items-start">
              <div>
                <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 to-blue-500">
                  About Insight50
                </h2>
                <p className="text-gray-400 mt-1">
                  Performance analysis for SANFL Women's football
                </p>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="p-1 hover:bg-gray-800 rounded-lg transition-colors"
              >
                <X className="w-5 h-5 text-gray-400" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 space-y-6">
              <div>
                <h3 className="text-lg font-semibold text-emerald-400 mb-2">Overview</h3>
                <p className="text-gray-300">
                  Insight50 is a comprehensive analytics platform designed for football administrators, 
                  recruiters, and analysts to track and evaluate player performance in the SANFL Women's league.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-emerald-400 mb-2">Features</h3>
                <div className="space-y-2 text-gray-300">
                  <p>🏃‍♀️ <span className="font-medium text-white">Player Analysis:</span> Track individual player statistics, performance trends, and position-specific metrics</p>
                  <p>👥 <span className="font-medium text-white">Team Analysis:</span> View team performance data, top performers, and comparative statistics</p>
                  <p>📊 <span className="font-medium text-white">Quick Compare:</span> Side-by-side comparison of any two players with radar charts and key metrics</p>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-emerald-400 mb-2">Metrics Explained</h3>
                <div className="space-y-2 text-gray-300">
                  <p><span className="font-medium text-white">K:</span> Kicks</p>
                  <p><span className="font-medium text-white">HB:</span> Handballs</p>
                  <p><span className="font-medium text-white">M:</span> Marks</p>
                  <p><span className="font-medium text-white">T:</span> Tackles</p>
                  <p><span className="font-medium text-white">CM:</span> Contested Marks</p>
                  <p><span className="font-medium text-white">AF:</span> Fantasy Points</p>
                </div>
              </div>

              <div className="pt-4 border-t border-gray-800">
                <p className="text-sm text-gray-400">
                  Version 1.0 • Made with ❤️ for SANFL Women's Football
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AboutModal;